"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setItem = exports.removeItem = exports.removeAllItem = exports.getItem = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
/**
 * 存储数据
 */
var setItem = exports.setItem = function setItem(key, value) {
  // 将数组、对象类型的数据转化为 JSON 字符串进行存储
  if ((0, _typeof2.default)(value) === 'object') {
    value = JSON.stringify(value);
  }
  window.localStorage.setItem(key, value);
};

/**
 * 获取数据
 */
var getItem = exports.getItem = function getItem(key) {
  var data = window.localStorage.getItem(key);
  try {
    return JSON.parse(data);
  } catch (err) {
    return data;
  }
};

/**
 * 删除数据
 */
var removeItem = exports.removeItem = function removeItem(key) {
  window.localStorage.removeItem(key);
};

/**
 * 删除所有数据
 */
var removeAllItem = exports.removeAllItem = function removeAllItem(key) {
  window.localStorage.clear();
};